<script lang="ts">
	import { BaseInput, Button, ButtonSize, ButtonType, Icon } from '@repo/commons/components'
	import DocsLink from '../DocsLink.svelte'
	import type { IconName } from '$lib_commons/svg-icons/iconsMap.ts'

	interface Props {
		title: string
		titleIcon?: IconName
		documentationSubpath?: string
		documentationTitle?: string
		disableAddButton?: boolean
		leftSnippet?: import('svelte').Snippet
		rightSnippet?: import('svelte').Snippet
		searchPlaceholder?: string
		onSearch?: (value: string) => void
		addButtonText?: string
		addButtonIcon?: IconName | null
		onAdd?: () => void
	}

	let {
		title,
		titleIcon,
		documentationSubpath,
		documentationTitle,
		disableAddButton = false,
		leftSnippet,
		rightSnippet,
		searchPlaceholder = 'Search',
		onSearch,
		onAdd,
		addButtonText = 'Add',
		addButtonIcon = 'plus'
	}: Props = $props()

	let value = $state('')
</script>

<div class="header" class:has-filter-snippet={!!leftSnippet}>
	<div class="title-section">
		<div class="flex items-center gap-1">
			{#if titleIcon}
				<Icon name={titleIcon} size="md" class="text-brand" />
			{/if}
			{#if title}
				<h1 class="page-title">{title}</h1>
			{/if}
			{#if documentationSubpath && documentationTitle}
				<DocsLink docSubpath={documentationSubpath} title={documentationTitle} />
			{/if}
		</div>
		{#if leftSnippet}
			{@render leftSnippet()}
		{/if}
	</div>

	<div class="flex items-center gap-2">
		{#if onSearch}
			<div class="search-wrapper">
				<BaseInput
					{value}
					size="md"
					placeholder={searchPlaceholder}
					clearable
					onInput={(newValue: string) => {
						value = newValue
						onSearch?.(value)
					}}
					prepend={{
						component: Icon,
						props: {
							name: 'search',
							size: 'md',
							class: 'text-[#002C4D80]'
						}
					}}
				/>
			</div>
		{/if}
		{#if onAdd}
			<Button
				buttonText={addButtonText}
				disabled={disableAddButton}
				buttonSize={ButtonSize.LARGE}
				buttonType={ButtonType.NEUTRAL}
				icon={addButtonIcon ? Icon : undefined}
				iconProps={addButtonIcon ? { name: addButtonIcon } : undefined}
				onclick={onAdd}
			/>
		{/if}
		{#if rightSnippet}
			{@render rightSnippet()}
		{/if}
	</div>
</div>

<style lang="postcss">
	.header {
		@apply flex justify-between items-center py-4 gap-6;

		&.has-filter-snippet {
			@apply items-end;
		}
	}
	.title-section {
		@apply flex flex-col gap-6;
	}
	.page-title {
		@apply text-2xl font-semibold text-[#001626E5];
	}
	.search-wrapper {
		@apply max-w-full w-[220px];
	}
</style>
